export default class TransactionRequest {

    constructor(jsonResponse) {

        this.quotationReference = jsonResponse["quotation-reference"];
        this.registrationId = jsonResponse["registration-id"];
        this.capturedFields = jsonResponse["captured-fields"];
        this.saveBeneficiary = jsonResponse["save-beneficiary"];
    }

    static create(quotationReference, registrationId, capturedFields, saveBeneficiary) {

        let request = {};
        request.quotationReference = quotationReference;
        request.registrationId = registrationId;
        request.capturedFields = capturedFields;
        request.saveBeneficiary = saveBeneficiary;
        return request;
    }

    static toJson = function (obj) {
        let jsonObj = {};
        jsonObj["quotation-reference"] = obj.quotationReference;
        jsonObj["registration-id"] = obj.registrationId;
        jsonObj["captured-fields"] = obj.capturedFields;
        jsonObj["save-beneficiary"] = obj.saveBeneficiary;
        return jsonObj;
    };
}
